import { useState } from "react";
import Card from "./Card/Card";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PendingPayment from "./orders/PendingPayment";
import ValidatePayment from "./orders/ValidatePayment";
import PreparingOrder from "./orders/PreparingOrder";
import ShippOrder from "./orders/ShippOrder";
import CancelOrders from "./orders/CancelOrders";
import InvoicedOrder from "./orders/InvoicedOrder";
import {
  ShoppingBag,
  HourglassEmpty,
  CheckCircleOutline,
  LocalShipping,
  Receipt,
  Cancel,
} from "@mui/icons-material";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`orders-tabpanel-${index}`}
      aria-labelledby={`orders-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `orders-tab-${index}`,
    "aria-controls": `orders-tabpanel-${index}`,
  };
}

const tabConfig = [
  { label: "Pendientes", icon: <ShoppingBag sx={{ fontSize: 18 }} /> },
  { label: "Validando pago", icon: <HourglassEmpty sx={{ fontSize: 18 }} /> },
  { label: "En preparación", icon: <CheckCircleOutline sx={{ fontSize: 18 }} /> },
  { label: "Enviados", icon: <LocalShipping sx={{ fontSize: 18 }} /> },
  { label: "Facturados", icon: <Receipt sx={{ fontSize: 18 }} /> },
  { label: "Cancelados", icon: <Cancel sx={{ fontSize: 18 }} /> },
];

export const ProfileOrders = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 1, md: 3 }, pb: 6 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 3,
          pt: 2,
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #801F56 0%, #D87390 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ShoppingBag sx={{ color: "#fff", fontSize: 24 }} />
        </Box>
        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 800,
              color: "#333",
              letterSpacing: "-0.5px",
            }}
          >
            Mis Pedidos
          </Typography>
          <Typography variant="body2" sx={{ color: "#888" }}>
            Consulta el estado de tus compras
          </Typography>
        </Box>
      </Box>

      {/* Tabs */}
      <Box
        sx={{
          borderRadius: 3,
          background: "#fff",
          boxShadow: "0 2px 12px rgba(128, 34, 87, 0.08)",
          border: "1px solid #F3E0EB",
          overflow: "hidden",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: 56,
            borderBottom: "1px solid #F3E0EB",
            "& .MuiTabs-indicator": {
              backgroundColor: "#801F56",
              height: 3,
              borderRadius: "3px 3px 0 0",
            },
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: { xs: "0.75rem", md: "0.85rem" },
              color: "#888",
              minHeight: 56,
              py: 0,
              "&.Mui-selected": {
                color: "#801F56",
              },
            },
          }}
        >
          {tabConfig.map((tab, i) => (
            <Tab
              key={i}
              label={tab.label}
              icon={tab.icon}
              iconPosition="start"
              {...a11yProps(i)}
              sx={{
                gap: 0.5,
                "& .MuiSvgIcon-root": {
                  mr: 0.5,
                },
              }}
            />
          ))}
        </Tabs>

        <Box sx={{ px: { xs: 1.5, md: 3 }, py: 1 }}>
          <TabPanel value={value} index={0}>
            <PendingPayment />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ValidatePayment />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <PreparingOrder />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <ShippOrder />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <InvoicedOrder />
          </TabPanel>
          <TabPanel value={value} index={5}>
            <CancelOrders />
          </TabPanel>
        </Box>
      </Box>
    </Box>
  );
};
